goog.provide('el8.util.perfMark');

/**
 * Small, simple, utility module to cut down on the boilerplate
 * of using the PerformanceTiming API.
 */
el8.util.perfMark = (function () {
  return {
    /**
     * Passthrough function for performance.mark. Prefer using this instead.
     */
    mark: function (name) {
      performance.mark(name);
    },
    /**
     * Same thing as performance.measure except it swallows exceptions when
     * the starting mark does not exist.
     */
    measure: function (name, startName, stopName) {
      try {
        return performance.measure(name, startName, stopName);
      } catch (err) {
        console.log("Performance Mark was never created: " + startName);
      }
    },
    /**
     * Creates a PerformanceMark for the provided name that is specifically
     * to mark the start of some duration based measurement.
     * 
     * The created PerformanceMark will have a common :start suffix appended
     * to the provided name.
     * @param {string} name 
     */
    start: function (name) {
      performance.mark(name + ":start");
    },
    /**
     * Creates a PerformanceMark for the provided name that is specifically
     * to mark the end of some duration based measurement.
     * 
     * The created PerformanceMark will have a common :stop suffix appended
     * to the provided name.
     * @param {string} name 
     * @returns {PerformanceMeasure}
     */
    stop: function (name) {
      try {
        performance.mark(name + ":stop");
        return performance.measure(name, name + ":start", name + ":stop");
      } catch (err) {
        return undefined;
      }
    },
    /**
     * Decorates the provided function with Performance Timing information
     * @param {string} name 
     * @param {Function} fn 
     * @returns {Function}
     */
    instrument: function (name, fn) {
      return function () {
        performance.mark(name + ':start');
        fn.apply(this, arguments);
        try {
          performance.mark(name + ":stop");
          performance.measure(name, name+":start", name+":stop");
        } catch (err) {
          console.log("Performance Mark was never created: " + name + ":start");
        }
      }
    }
  }
})();